histories-line-created
  span.event {this.locale().event}
  script(type="typescript").
    this.mixin('histories.base');
